export const isWebview = () => {
    return !!navigator.userAgent.match('UaeDealerApp');
};